import type { IItem } from 'interfaces/IInput';

/**
 * What the closed dropdown shows (OP-2534): every target when there are one
 * or two, otherwise the first two and how many more — "Ryegrass, Wild oats
 * +2". The field truncates if even that doesn't fit; its tooltip lists all.
 */
export const summariseTargets = (items: IItem[]): string => {
  if (items.length <= 2) return items.map((item) => item.item).join(', ');
  return `${items
    .slice(0, 2)
    .map((item) => item.item)
    .join(', ')} +${items.length - 2}`;
};
